module.exports = "query Campaigns {\n  campaigns {\n    id\n    name\n    description\n    goal\n    raised\n    endDateTime\n  }\n}"